import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, Envelope } from "@phosphor-icons/react";
import { animateContactInfo } from "./gsap-footer";
import {
  BUSINESS_NAME,
  BUSINESS_HOURS,
  BUSINESS_CONTACT_PHONE,
  BUSINESS_CONTACT_EMAIL,
} from "@/core/constants/business";

const ContactInfo = () => {
  const contactRef = useRef<HTMLDivElement>(null);

  // Format business hours for display
  const formattedHours = (() => {
    // Check if all days have the same hours (which they do according to the data)
    const uniqueHours = new Set(Object.values(BUSINESS_HOURS));
    if (uniqueHours.size === 1) {
      return `Open Daily: ${BUSINESS_HOURS.monday.replace(
        /^(\d+):00\s/,
        "$1"
      )}`;
    }
    // If hours differ by day (not the case currently, but future-proof)
    return Object.entries(BUSINESS_HOURS).map(
      ([day, hours]) =>
        `${day.charAt(0).toUpperCase() + day.slice(1)}: ${hours}`
    );
  })();

  useEffect(() => {
    if (contactRef.current) {
      // Add a small delay to ensure footer animation has started
      const timer = setTimeout(() => {
        if (contactRef.current) {
          animateContactInfo(contactRef.current);
        }
      }, 600);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <h1 className="text-xl font-bold mb-5 text-cannabis-green-300">
        Visit Our Dispensary
      </h1>
      <address ref={contactRef} className="not-italic space-y-4">
        <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <MapPin
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">
            3400 Connecticut Avenue NW
            <br />
            Washington, DC 20008
          </p>
        </div>

        <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <Clock
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">{formattedHours}</p>
        </div>

        {/* <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <Phone
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">
            <a
              href={`tel:${BUSINESS_CONTACT_PHONE}`}
              className="hover:text-cannabis-green-300 transition-colors"
            >
              {BUSINESS_CONTACT_PHONE}
            </a>
          </p>
        </div> */}

        {/* <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <Envelope
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">
            <a
              href={`mailto:${BUSINESS_CONTACT_EMAIL}`}
              className="hover:text-cannabis-green-300 transition-colors"
            >
              {BUSINESS_CONTACT_EMAIL}
            </a>
          </p>
        </div> */}

        <div className="pt-4">
          <Link
            to="/contact"
            className="inline-block btn-primary"
            aria-label={`Contact ${BUSINESS_NAME} cannabis dispensary`}
          >
            Contact Us
          </Link>
        </div>
      </address>
    </>
  );
};

export default ContactInfo;
